export const FACILITY_QUERY_PARAM = 'facilityId';
export const CARE_AREA_QUERY_PARAM = 'careAreaId';
